import { PublicClientApplication, Configuration, LogLevel, PopupRequest, EventMessage, EventType } from '@azure/msal-browser';

const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_OPENID_CLIENTID, // Твой Client ID
    authority: import.meta.env.VITE_OPENID_CONNECT_DISCOVERY_ENDPOINT, // Policy в Azure B2C
    knownAuthorities: [import.meta.env.VITE_OPENID_KNOWN_AUTHORITIES], // Домен B2C
    redirectUri: `${window.location.origin}`, // URL для редиректа после логина
    postLogoutRedirectUri: `${window.location.href}`, // Indicates the page to navigate after logout.
    // navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: "localStorage", // Или "localStorage"
  },
  system: {
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        console.log(message);
      },
      logLevel: LogLevel.Trace,
      piiLoggingEnabled: false
    }
  }
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest: PopupRequest = {
  scopes: ['openid', 'profile'],
};

msalInstance.addEventCallback((event: EventMessage) => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
    event.payload &&
    "account" in event.payload &&
    event.payload.account
  ) {
    msalInstance.setActiveAccount(event.payload.account);
  }
});
